import React from "react";

class CustomizationBanner extends React.Component{
	render(){
		return (
			<div id="custBanner" className="compBanner">
          <div className="compWrapper">
            <section className="col2">
              <div className="bannerDesc">
                  <h1 id="bannerTitle">META PowerSchool Customizations</h1>
                  <h2>Making the PowerSchool Experience better.</h2>
              </div>
            </section>
          </div>
          <div className="circles">
            <div className="circle3"></div>
            <div className="circle4"></div>
          </div>
      </div>
		);
	}
}

export default CustomizationBanner;